import React from "react";
import "./Footer.css";
const Footer = () => {
  const footerItems = [
    {
      id: 1,
      label: "Cookie-Hinweis",
      href: "https://www.mars.com/cookies-germany",
      className: "text-lg-start",
    },
    {
      id: 2,
      label: "Datenschutz",
      href: "https://www.mars.com/privacy-policy-germany",
      className: "text-lg-center",
    },
    {
      id: 3,
      label: "Barrierefreiheit",
      href: "https://www.mars.com/accessibility-german",
      className: "text-lg-center",
    },
    {
      id: 4,
      label: "Rechtliches",
      href: "https://www.mars.com/legal-germany",
      className: "text-lg-center",
    },
    {
      id: 5,
      label: "AGB",
      href: "https://www.jameswellbeloved.de/pages/terms-and-conditions",
      className: "text-lg-end",
    },
  ];

  return (
    <div style={{backgroundColor: "#006243"}}>
    <div className="footer-container">
      <footer className="pt-3 mt-4 pb-4 footer">
        {/* <ul className="nav d-flex justify-content-between pb-3 mb-4 footer-items-wrapper">
          {footerItems.map(({ id, label, href, className }) => {
            return (
              <li
                key={id}
                className={`${className} nav-item`}
                // style={{flexBasis: "50px"}}
              >
                <a href={href} className="nav-link p-0 py-2 text-white">
                  {label}
                </a>
              </li>
            );
          })}
        </ul> */}
        <ul className="nav footer-items-wrapper d-flex flex-wrap list-unstyled justify-content-center justify-content-md-between mb-3 pb-lg-4">
          {footerItems.map(({ id, label, href, className }) => {
            return (
              <li
                key={id}
                className={`p-2 p-sm-3 px-md-0 py-md-3 p-lg-0 col-lg-2 nav-item footer-list ${className}`}
              >
                <a href={href} className="nav-link p-0 text-white">
                  {label}
                </a>
              </li>
            );
          })}
        </ul>
        <div className="footer-copyright text-white text-center mx-auto">
          <span>
            © 2025 Mars, Incorporated. All Rights Reserved. ®TM JAMES
            WELLBELOVED is a Trademark of Mars, Incorporated and its affiliates.
          </span>
        </div>
      </footer>
    </div>
    </div>
  );
};

export default Footer;
